export default function DashboardIcon({
    style,
    fill="#E8E8E8",
}){
    return <svg style={style} width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.9259 8.04633L12.7638 13.4939C11.6028 15.4939 13.0458 18 15.3583 18H26C26.2652 18 26.5196 17.8946 26.7071 17.7071C26.8946 17.5196 27 17.2652 27 17V14C27 12.2886 26.6621 10.5941 26.0057 9.01359C25.3492 7.4331 24.3872 5.99777 23.1747 4.78996C21.9623 3.58215 20.5232 2.62563 18.9402 1.97527C17.3572 1.32491 15.6614 0.993514 13.95 1.0001C6.775 1.0251 1 6.95006 1 14.1375V17.963L5.33333 18" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.1528 6.27095L17.2721 10.9864L12.9665 8.44452L17.1528 6.27095Z" fill={fill}/>
    </svg>    
}